// Stats
const animationDuration = 2000;
const frameDuration = 1000 / 60;
const counters = document.getElementsByClassName("stats-container");
const totalFrames = Math.round( animationDuration / frameDuration );
const arrayLength = counters.length;
const easeOutQuad = t => t * ( 2 - t );
const animateCountUp = el => {
    let frame = 0;
    const countTo = parseInt( el.innerHTML, 10 );
    const counter = setInterval( () => {
        frame++;
        const progress = easeOutQuad( frame / totalFrames );
        const currentCount = Math.round( countTo * progress );
        if ( parseInt( el.innerHTML, 10 ) !== currentCount ) {
            el.innerHTML = currentCount;
        }
        if ( frame === totalFrames ) {
            clearInterval( counter );
        }
    }, frameDuration );
};
// Run when visible
for (let i = 0; i < arrayLength; i++) {
    const countupEls = document.querySelectorAll( '.countup' );
    var observer = new IntersectionObserver(function(entries) {

        if(entries[0].isIntersecting === true && !counters[i].classList.contains("run")) {
            counters[i].classList.add("run")
            countupEls.forEach(animateCountUp);
        }
    }, { threshold: [0] });
    observer.observe(counters[i]);
}
